import { cn } from '@/lib/utils';
import { useFileDrop } from '@/hooks/useFileDrop';

// Wraps a single photo slot's outer element, turning it into a file drop target
// without disturbing its existing click (select) / mouse-drag (pan) handlers,
// which are passed straight through. Dragging files over the slot adds the
// `ins-slot-drop-over` highlight; dropping reports the files with the slot key.
export interface SlotDropWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  slotKey: string;
  onDropPhoto: (slotKey: string, files: File[]) => void;
  /** Block drops (e.g. while this slot is already uploading). */
  disabled?: boolean;
}

export function SlotDropWrapper({ slotKey, onDropPhoto, disabled, className, children, ...rest }: SlotDropWrapperProps) {
  const { isDragOver, dropHandlers } = useFileDrop({
    onFiles: (files) => onDropPhoto(slotKey, files),
    disabled,
  });

  return (
    <div {...rest} {...dropHandlers} className={cn(className, isDragOver && 'ins-slot-drop-over')}>
      {children}
    </div>
  );
}
